/** EmbedRadio · /embed/radio · chrome-free player for third-party sites */
import React from "react";
import { SovereignRadioPlayer } from "@/components/cathedral/SovereignRadioPlayer";

export default function EmbedRadio() {
  return (
    <div style={{ minHeight: "100vh", background: "#0a0a0f", padding: 12 }} data-testid="embed-radio-page">
      <p className="font-mono uppercase tracking-[0.26em] text-center mb-2" style={{ fontSize: 10, color: "#FFD700" }}>
        ◉ The Sovereign Pulse · NextXus Radio
      </p>
      <SovereignRadioPlayer />
      <p className="text-center mt-2">
        <a
          href="https://nextxus.online/radio"
          target="_blank"
          rel="noopener noreferrer"
          className="font-mono uppercase tracking-[0.2em]"
          style={{ fontSize: 9, color: "rgba(0,255,204,0.7)", textDecoration: "none" }}
        >
          nextxus.online/radio ↗
        </a>
      </p>
    </div>
  );
}
